import {
  $http
} from "../service/service.js";
let http = {}
let $data = {
  login: (data) => {
    http.url = 'api/auth/login';
    http.data = data;
    http.method = 'post';
    return $http.post(http);
  },
  get: (data) => {
    return $http.get(data);
  },
  getUserInfo: (info) => {
    http.url = 'userTable/getUserInfo';
    http.data = info;
    return $http.post(http);
  },

  queryAllByLimit: (type_name, info, load) => {
    http.url = type_name + '/queryAllByLimit';
    http.method = 'post';
    http.data = info;
    http.load = load;
    return $http.post(http);
  },

  selectOne: (type_name, info) => {
    http.url = type_name + '/selectOne';
    http.data = info;
    http.method = 'post';
    return $http.post(http);
  },

  update: (type_name, info) => {
    http.url = type_name + '/update';
    http.data = info;
    http.method = 'post';
    return $http.post(http);
  },

  insert: (type_name, info) => {
    http.url = type_name + '/insert';
    http.data = info;
    http.method = 'post';
    return $http.post(http);
  },

  batchDelete: (type_name, info) => {
    http.url = type_name + '/batchDelete';
    http.data = info;
    http.method = 'post';
    return $http.post(http);
  },
  queryInitData: (info) => {
    http.url = 'userTable/queryInitData';
    http.data = info;
    return $http.post(http);
  },

  queryAllByLimitByMajor: (info) => {
    http.url = 'collegeTable/queryAllByLimitByMajor';
    http.data = info;
    return $http.post(http);
  },

  queryIndexNews: (info) => {
    http.url = 'newsTable/queryIndexNews';
    http.data = info;
    return $http.post(http);
  },
  majorType_selectAll: (info) => {
    http.url = 'majorType/selectAll';
    http.data = info;
    return $http.post(http);
  },
  queryAllByArea: (info) => {
    http.url = 'newsTable/queryAllByArea';
    http.data = info;
    return $http.post(http);
  },
  queryAllVolunteer: (info) => {
    http.url = 'scoreInfoZy/queryAllVolunteer';
    http.data = info;
    return $http.post(http);
  },

  getYiJian: (info) => {
    http.url = 'scoreInfoZy/getYiJian';
    http.data = info;
    return $http.post(http);
  },

  collegeYijianbao: (info) => {
    http.url = 'collegeSun/collegeYijianbao';
    http.data = info;
    return $http.post(http);
  },






  collegeTianbao: (info) => {
    http.url = 'collegeSun/collegeTianbao';
    http.data = info;
    return $http.post(http);
  },

  majorTianbao: (info) => {
    http.url = 'majorSun/majorTianbao';
    http.data = info;
    return $http.post(http);
  },


  queryScorByCollege: (info) => {
    http.url = 'scoreInfoZy/queryScorByCollege';
    http.data = info;
    return $http.post(http);
  },
  queryMajorScorByCollegeScore: (info) => {
    http.url = 'scoreInfoZy/queryMajorScorByCollegeScore';
    http.data = info;
    return $http.post(http);
  },



  queryZyByTypeLimit: (info) => {
    http.url = 'scoreInfoZy/queryZyByTypeLimit';
    http.data = info;
    return $http.post(http);
  },
  queryZyByTypechildLimit: (info) => {
    http.url = 'scoreInfoZy/queryZyByTypechildLimit';
    http.data = info;
    return $http.post(http);
  },
  queryScoreByCollegeMajor: (info) => {
    http.url = 'scoreInfoZy/queryScoreByCollegeMajor';
    http.data = info;
    return $http.post(http);
  },
  queryScoreOldByCollege: (info) => {
    http.url = 'collegeSun/queryScoreOldByCollege';
    http.data = info;
    return $http.post(http);
  },
  queryScoreOldByMajor: (info) => {
    http.url = 'majorSun/queryScoreOldByMajor';
    http.data = info;
    http.load = true;
    return $http.post(http);
  },

  queryCollegeMajorScore: (info) => {
    http.url = 'collegeSun/queryCollegeMajorScore';
    http.data = info;
    http.load = true;
    return $http.post(http);
  },


  queryZyByCollegeLimit: (info) => {
    http.url = 'scoreInfoZy/queryZyByCollegeLimit';
    http.data = info;
    return $http.post(http);
  },
  queryOldZyByMajorLimit: (info) => {
    http.url = 'majorSun/queryOldZyByMajorLimit';
    http.data = info;
    return $http.post(http);
  },

  getinitData: (info) => {
    http.url = 'userTable/queryInitData';
    http.data = info;
    http.load = false;
    return $http.post(http);
  },

  queryByuserId: (info) => {
    http.url = 'userScore/queryByuserId';
    http.data = info;
    return $http.post(http);
  },

  queryphone: (info) => {
    http.url = 'sendverification/queryphone';
    http.data = info;
    return $http.post(http);
  },
  sendoldphonecode: (info) => {
    http.url = 'sendverification/sendoldphonecode';
    http.data = info;
    return $http.post(http);
  },
  sendoldphonecodeverification: (info) => {
    http.url = 'sendverification/sendoldphonecodeverification';
    http.data = info;
    return $http.post(http);
  },
  sendonewphonecode: (info) => {
    http.url = 'sendverification/sendonewphonecode';
    http.data = info;
    http.load = false;
    return $http.post(http);
  },
  sendnewphonecodeverification: (info) => {
    http.url = 'sendverification/sendnewphonecodeverification';
    http.data = info;
    return $http.post(http);
  },
  updatepwdverification: (info) => {
    http.url = 'sendverification/updatepwdverification';
    http.data = info;
    return $http.post(http);
  },
  sendphonecodelogin: (info) => {
    http.url = 'sendverification/sendphonecodelogin';
    http.data = info;
    return $http.post(http);
  },



  updatephone: (info) => {
    http.url = 'userTable/updatephone';
    http.data = info;
    return $http.post(http);
  },

  ExportExcel: (info) => {
    http.url = 'volunteerTable/ExportExcel';
    http.data = info;
    return $http.post(http);
  },



  getRankByscore: (info) => {
    http.url = 'scoreRank/getRankByscore';
    http.data = info;
    http.load = false
    return $http.post(http);
  },
  queryAllScoreRank: (info) => {
    http.url = 'scoreRank/queryAllScoreRank';
    http.data = info;
    return $http.post(http);
  },

  queryAllbyFirstYear: (info) => {
    http.url = 'provincialTable/queryAllbyFirstYear';
    http.data = info;
    return $http.post(http);
  },
  queryAllByLimitInfoScore: (info) => {
    http.url = 'collectionTable/queryAllByLimitInfoScore';
    http.data = info;
    return $http.post(http);
  },
  queryAllByLimitScoreInfo: (info) => {
    http.url = 'collectionTable/queryAllByLimitScoreInfo';
    http.data = info;
    return $http.post(http);
  },
  queryAlldata: (info) => {
    http.url = 'collegeTable/queryAlldata';
    http.data = info;
    return $http.post(http);
  },

  queryByGbLimit: (info) => {
    http.url = 'userTable/queryByGbLimit';
    http.data = info;
    return $http.post(http);
  },
  userGaoInfoUpdate: (info) => {
    http.url = 'userGaoInfo/userGaoInfoUpdate';
    http.data = info;
    return $http.post(http);
  },
  queryAllById: (info) => {
    http.url = 'userGaoInfo/queryAllById';
    http.data = info;
    return $http.post(http);
  },
  getMemberNum: (info) => {
    http.url = 'memberTable/getMemberNum';
    http.data = info;
    return $http.post(http);
  },



  signOut: (info) => {
    http.url = 'userTable/signOut';
    http.data = info;
    return $http.post(http);
  }

}

export default $data;



// WEBPACK FOOTER //
// ./src/api/data.js